import React, { useState, useEffect } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextareaAutosize } from '@mui/material';
import { Button } from '@mui/material';
import { useFormik } from "formik";
import { inject, observer } from 'mobx-react';
import { message } from 'antd';

const CommentModal = (props) => {
  let { open, handleClose, workCode, onCommentSuccess, workStore } = props;

  const formik = useFormik({
    initialValues: {
      content: ''
    },
    onSubmit: async (values) => {
      try {
        await workStore.createCommentWork(workCode, values);
        message.success('Đăng ý kiến thành công!')
        onCommentSuccess()
      } catch (err) {
        console.log(err);
      } finally {
        workStore.getCommentWorkList(workCode);
      }
    },
  });
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100vw",
            maxWidth: "100vw", // Set your width here
            mx: 0,
          },
        },
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#23374D] !pt-8"
          sx={{
            fontWeight: 700,
          }}
        >
          <span className="font-bold">Đăng ý kiến</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
            className="min-h-[179px] mt-4"
          >
            <TextareaAutosize
              id='content'
              name='content'
              minRows={6}
              placeholder='Nhập nội dung'
              className='bg-[#F8F8F8] w-full p-3 rounded-md'
              onChange={formik.handleChange}
            />
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{ fontWeight: 600 }}
            onClick={handleClose}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary"
          >
            Đóng
          </Button>
          <button
            type="submit"
            sx={{ fontWeight: 600 }}
            className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]"
            onClick={handleClose}
          >
            Gửi
          </button>
        </DialogActions>
      </form>

    </Dialog>
  )
}
export default inject("workStore")(observer(CommentModal));
